import { useState, useEffect } from 'react';
import { validateEmbeddedToken } from '@/redux/actions/gravityActions.js';
import readEmbeddedEndUserToken from '@/lib/embeddedEndUserToken/readEmbeddedEndUserToken.js';
import clearEmbeddedEndUserToken from '@/lib/embeddedEndUserToken/clearEmbeddedEndUserToken.js';
import removeLegacyEmbeddedEndUserToken from '@/lib/embeddedEndUserToken/removeLegacyEmbeddedEndUserToken.js';

const useEmbeddedAuth = () => {
  const [isEmbeddedEndUser, setIsEmbeddedEndUser] = useState(false);
  const [embeddedToken, setEmbeddedToken] = useState(null);
  const [isEmbeddedValid, setIsEmbeddedValid] = useState(false);
  const [isValidating, setIsValidating] = useState(false);

  useEffect(() => {
    removeLegacyEmbeddedEndUserToken();
    const token = readEmbeddedEndUserToken();

    if (token) {
      setEmbeddedToken(token);
      setIsValidating(true);
      validateTokenWithAPI(token);
    } else {
      setIsEmbeddedEndUser(false);
      setIsEmbeddedValid(false);
      setEmbeddedToken(null);
      setIsValidating(false);
    }
  }, []);

  const validateTokenWithAPI = async (token) => {
    try {
      const response = await validateEmbeddedToken({ token });

      if (response?.success && response?.valid) {
        setIsEmbeddedValid(true);
        setIsEmbeddedEndUser(true);
      } else {
        setIsEmbeddedValid(false);
        setIsEmbeddedEndUser(false);
        clearEmbeddedEndUserToken();
        setEmbeddedToken(null);
      }
    } catch (error) {
      console.error('Failed to validate embedded token:', error);
      setIsEmbeddedValid(false);
      setIsEmbeddedEndUser(false);
      clearEmbeddedEndUserToken();
      setEmbeddedToken(null);
    } finally {
      setIsValidating(false);
    }
  };

  return {
    isEmbeddedEndUser,
    embeddedToken,
    isEmbeddedValid,
    isValidating
  };
};

export default useEmbeddedAuth;
